if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Tapping the dark shell/image closes the media modal; interactive
        // controls keep their native behavior.
        this.addEventListener('click', (event) => {
          const t = event.target;
          if (!t || !t.closest) return;
          if (t.closest('button, a, video, iframe, model-viewer, .product-media-modal__toggle')) return;
          if (t.tagName === 'IMG' || t === this || t.classList.contains('product-media-modal__dialog')) {
            this.hide();
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy || !this.openedBy.getAttribute) return;
        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width && container.clientWidth) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube') &&
          typeof activeMedia.loadContent === 'function'
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
